import { request } from '@/common/request';

const prefix = '';
export const downloadFile = (fileId: string) => {
  const url = `${prefix}/cos/download`;
  return request.post(
    url,
    { key: fileId },
    {
      // @ts-ignore
      hiddenErrorMsg: true,
    },
  );
};
// @todo 上传文件
// @author Herisson Pan
// @date 2022/7/7
export function uploadFile(data: any) {
  return request({
    url: '/cos/upload',
    method: 'post',
    data,
  });
}

// @todo 副文本上传文件
// @author Herisson Pan
// @date 2022/7/7
export function cosResourceUploadFile(data: any) {
  return request({
    url: '/cos/resource/upload',
    method: 'post',
    data,
  });
}

// 机构列表
export const getAgencyList = (userId: string) => {
  const url = '/system/user/organizes';
  return request.post<any, any>(url, { userId });
};

/**
 * 查询组织列表
 * @param userId  用户编号
 * @returns
 */
export const getAgencyListByOrganizeId = (userId: string) => {
  const url = `/system/user/organizes/${userId}`;
  return request.get<any, any>(url);
};

/** 将用户关联到某个机构/项目 */
export const httpBindOrganize = (params: any) => {
  const url = '/system/user/organize/bind';
  return request.post<any, any>(url, params);
};

// 医院列表
export const getHospitalList = (params: any) => {
  const url = '/hospital/listPage';
  return request.post<any, any>(url, params);
};
// 科室列表
export const getDepartmentList = (params: any) => {
  const url = '/department/listPage';
  return request.post<any, any>(url, params);
};
// 职称列表
export const getJobTitleList = (params: any) => {
  const url = '/jobTitle/listPage';
  return request.post<any, any>(url, params);
};
// 获取账号登录信息
export const getDoctorAccount = (params: any) => {
  const url = '/agency/getUser';
  return request.post<any, any>(url, params);
};
// 切换项目/机构
export const switchOrganize = (params: any) => {
  const url = '/system/user/organize/switch';
  return request.post<any, any>(url, params);
};
// 获取病例模拟域名
export const getDomain = () => {
  const url = '/simulation/getDomain';
  return request.get<any, any>(url);
};
// 用户指引状态
export const getGuideStatus = (params: any) => {
  const url = '/guide/status';
  return request.post<any, any>(url, params);
};
// 保存指引状态
export const saveGuideStatus = (params: any) => {
  const url = '/guide/complete';
  return request.post<any, any>(url, params);
};

/**
 * 获取预览地址前缀
 * @returns Promise<{ retMsg: string; retCode: number; data: string }>
 */
export const getPreviewPrefix = () => {
  const url = '/cos/preview/prefix';
  return request.get<any, string>(url);
};

/**
 * 获取下载地址前缀
 * @returns Promise<{ retMsg: string; retCode: number; data: string }>
 */
export const getDownloadPrefix = () => {
  const url = '/cos/download/prefix';
  return request.get<any, string>(url);
};

export default {
  downloadFile,
};
